// src/modules/app-views/offers/pages/Document/tabs/RecordTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import OfferBasicCard from './OfferBasicCard';
import OfferLeadsDistributionCard from './OfferLeadsDistributionCard';
import OfferLandingPagesCard from './OfferLandingPagesCard';
import OfferValidityCard from './OfferValidityCard';
import OfferPricingCard from './OfferPricingCard';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const OffersRecordTab = props => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div>
      <OfferBasicCard {...props} />
      <OfferLeadsDistributionCard {...props} />
      <OfferLandingPagesCard {...props} />
      {/*<OfferValidityCard {...props} />*/}
      {/*<OfferPricingCard {...props} />*/}
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default OffersRecordTab;
